const LOCATION_STORAGE_KEY = 'service_location';

export const getSavedLocation = (): string => {
  try {
    return localStorage.getItem(LOCATION_STORAGE_KEY) || "";
  } catch (e) {
    console.error("Error accessing localStorage:", e);
    return "";
  }
}; 